import type { JSX } from 'react'

export const AECardIcon = (): JSX.Element => (
  <use href='#aeCard' height='100%' width='100%' />
)
